import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { RastreamentoPedidoHistoricoInternoOutput } from 'src/app/@shared/models/consulta-detalhes-interno';
import { ConsultaDetalheInternaService } from 'src/app/services/consulta-detalhe-interna/consulta-detalhe-interna.service';

@Component({
  selector: 'app-bloco-historico-consulta',
  templateUrl: './bloco-historico-consulta.component.html',
  styleUrls: ['./bloco-historico-consulta.component.scss']
})
export class BlocoHistoricoConsultaComponent implements OnInit {
  @Input("PedidoId") pedidoId: number;
  displayedColumns: string[] = ["data", "etapa", "responsavel", "registro", "localidade"];
  dataSource: RastreamentoPedidoHistoricoInternoOutput[];
  isLoading: boolean = false;

  constructor(
    private consultaDetalhesService: ConsultaDetalheInternaService,
    public snackBar: MatSnackBar
  ) {}

  ngOnInit() {
    if (this.pedidoId) this.loadPedidoHistorico();
  }

  loadPedidoHistorico() {
    this.isLoading = true;
    this.consultaDetalhesService
      .getHistoricoRastreamento(this.pedidoId)
      .subscribe(
        (response: RastreamentoPedidoHistoricoInternoOutput[]) => {
          this.dataSource = response;
        },
        (err: HttpErrorResponse) => {
          this.openSnackBar(
            "Erro ao carregar histórico, entre em contato com o suporte : " + err.error.Protocolo ?? err.error.Message,
            "OK",
            10000,
            "danger-snackbar"
          );
        }
      ).add(()=> this.isLoading = false);
  }

  openSnackBar(
    message: string,
    action: string,
    duration: number,
    panelClass?: string
  ): any {
    this.snackBar.open(message, action, { duration, panelClass });
  }
}
